import classnames from "classnames";
import React, { useState } from "react";
import { CSSTransition } from "react-transition-group";
import { Portal } from "@lana-commerce/core/react/components/Portal";
import { RootCloseWrapper } from "@lana-commerce/core/react/components/RootCloseWrapper";
import { generateUUID } from "@lana-commerce/core/generateUUID";

import { KeyboardArrowDown } from "./icons/KeyboardArrowDown";
import { LanguageCurrency, LanguageCurrencyProps } from "./LanguageCurrency";
import { usePopperBasic } from "../utils/popper";

interface LocaleSelectorProps extends LanguageCurrencyProps {
  theme?: "dark" | "light";
}

export const LocaleSelector = (props: LocaleSelectorProps) => {
  const uuid = useState(() => generateUUID())[0];
  const pp = usePopperBasic("bottom");
  const [popupVisible, setPopupVisible] = useState(false);
  const onRootClose = () => {
    setPopupVisible(false);
  };
  const textClass = classnames({
    "txt-body-16 text-white": props.theme !== "light",
    "txt-body-14 text-body": props.theme === "light",
  });
  const arrowClass = classnames({
    "text-off-white": props.theme !== "light",
    "text-body": props.theme === "light",
  });
  return (
    <>
      <RootCloseWrapper tag={uuid} onRootClose={onRootClose} disabled={!popupVisible}>
        <div
          ref={pp.setReferenceElement}
          className="inline-flex items-center gap-1 cursor-pointer select-none"
          onClick={() => {
            setPopupVisible(!popupVisible);
          }}
        >
          <div className={textClass}>
            {props.language.toUpperCase()} | {props.currency}
          </div>
          <div className={arrowClass}>
            <KeyboardArrowDown className="w-6 h-6" />
          </div>
        </div>
      </RootCloseWrapper>
      <Portal>
        <CSSTransition in={popupVisible} timeout={200} mountOnEnter unmountOnExit>
          <RootCloseWrapper tag={uuid} onRootClose={onRootClose}>
            <div className="popup-menu" ref={pp.setPopperElement} style={pp.style} {...pp.attrs}>
              <LanguageCurrency
                {...props}
                onCurrencyChange={(v) => {
                  setPopupVisible(false);
                  props.onCurrencyChange(v);
                }}
                onLanguageChange={(v) => {
                  setPopupVisible(false);
                  props.onLanguageChange(v);
                }}
              />
            </div>
          </RootCloseWrapper>
        </CSSTransition>
      </Portal>
    </>
  );
};
